import { render, staticRenderFns } from "./personal_information.vue?vue&type=template&id=77e87f06&"
import script from "./personal_information.vue?vue&type=script&lang=js&"
export * from "./personal_information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports